<div class="app-container">
    <app-header></app-header>
    <app-toast-global></app-toast-global>
    <div class="app-content-container">
        <div class="sidebar-container" *ngIf="!hideSidebar">
            <app-sidebar (updateSize)="updateSize($event)"></app-sidebar>
        </div>
        <div class="main-content">
            <router-outlet></router-outlet>
        </div>
    </div>
    <app-footer></app-footer>
</div>